module.exports = __webpack_public_path__ + "static/media/ORGANIGRAMA NOTARÍA 51 DE BÓGOTA.4f25b22d.pdf";